import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Dialog, {DialogContent} from 'material-ui/Dialog'

import {missingInfo as styles} from '../styles'
import StepEmail from '../containers/email'
import StepPhone from '../containers/phone'

class Deposit extends React.Component {

  render() {
    const {step, close} = this.props
    return (
      <Dialog onClose={() => close()} open={step > 0} maxWidth="xs" fullWidth>
        <DialogContent>
          {step === 1 ? <StepEmail/> : null}
          {step === 2 ? <StepPhone/> : null}
        </DialogContent>
      </Dialog>
    )
  }
}

Deposit.propTypes = {
  step: PropTypes.number,
  nextStep: PropTypes.func,
  close: PropTypes.func,
}

export default withStyles(styles, {withTheme: true})(Deposit)



// WEBPACK FOOTER //
// ./src/sections/missingInfo/components/missingInfo.js